export default "__VITE_ASSET__CZEJ79Ra__"